import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-multipoint",
  "use": "icon-multipoint-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-multipoint\"><path d=\"M512 1024A512 512 0 10512 0a512 512 0 000 1024z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol